
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Begriff Somnambulismus bezeichnet Störungen des Schlafs (somnus), die mit einer Form der Bewegung (ambulation) einhergehen. `}<M mdxType="M">{`Somnambulismus hat verschiedene Erscheinungsformen wie das Schlafwandeln, das Sprechen und Essen im Schlaf, aber auch, dass man Sex im Schlaf hat oder im extremsten Fall: Totschlag im Schlaf.`}</M>{` All dies passiert in den tiefsten Phasen des traumfreien Non-REM-Schlafs. Darum erinnert sich jemand, der unter Somnambulismus leidet, nicht an die Dinge, die er während dieser Schlafphase macht. `}<br /><br />{`
Weckt man beispielsweise einen Schlafwandler und fragt ihn, was er gerade erlebt habt, kann er keine Antwort geben. Die Ursache für diese Episoden sind wissenschaftlich nicht bis ins Letzte geklärt. Vermutet wird, dass ein unerwarteter Anstieg der Aktivität im Nervenzentrum während des Tiefschlafs ein Auslöser sein könnte, schreibt Dr. Matthew Walker, Direktor des Schlaflabors der University of California in Berkeley in «Das grosse Buch vom Schlaf». Betroffen vom Schlafwandeln sind vor allem Kinder. `}<M mdxType="M">{`Bis zu 30 Prozent haben in ihrer Kindheit einmal ein Schlafwandel-Erlebnis.`}</M>{` Die meisten Vorfälle von Somnambulismus seien, so Walker, harmlos. Behandelt werden sollte er nur, wenn das Umfeld den Eindruck habe, die Gesundheit würde unter diesen nächtlichen Episoden leiden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;